package com.exura.features.plandefinition.domain.builder.series

import com.exura.features.plandefinition.domain.builder.BuilderField
import com.exura.features.plandefinition.domain.model.element.FloatingElement
import com.exura.features.plandefinition.domain.model.series.HourOfDay
import com.exura.features.plandefinition.domain.model.series.SeriesSpawnType
import com.exura.features.plandefinition.domain.model.series.SimpleFloatingSeries

class SimpleFloatingSeriesBuilderNew : BaseSeriesBuilder<FloatingElement, SimpleFloatingSeries>(
    SeriesSpawnType.FLOATING
) {

    private val instruction = BuilderField<String>(isRequired = true)
    private val durationInMinutes = BuilderField<Int>(isRequired = true, default = 5)
    private val deadline = BuilderField<Int?>()
    private val exactTime = BuilderField<HourOfDay?>()

    fun instruction(): String? = instruction.getValue()
    fun setInstruction(newValue: String) = apply {
        val res = instruction.setValue(newValue)
        updateChangedState(res)
        updateBuildState(res)
        updateElementsCalculationState(res)
    }

    fun durationInMinutes(): Int? = durationInMinutes.getValue()
    fun setDurationInMinutes(newValue: Int) = apply {
        val res = durationInMinutes.setValue(newValue)
        updateChangedState(res)
        updateBuildState(res)
        updateElementsCalculationState(res)
    }

    fun deadline(): Int? = deadline.getValue()
    fun setDeadline(newValue: Int?) = apply {
        val res = deadline.setValue(newValue)
        updateChangedState(res)
        updateBuildState(res)
        updateElementsCalculationState(res)
    }

    fun exactTime(): HourOfDay? = exactTime.getValue()
    fun setExactTime(newValue: HourOfDay?) = apply {
        val res = exactTime.setValue(newValue)
        updateChangedState(res)
        updateBuildState(res)
        updateElementsCalculationState(res)
    }

    fun setExactTime(hour: Int, minute: Int) = apply {
        setExactTime(HourOfDay(hour, minute))
    }

    override fun markSaved() = apply {
        instruction.markSaved()
        durationInMinutes.markSaved()
        deadline.markSaved()
        exactTime.markSaved()
        super.markSaved()
    }

    override fun validate(): List<String> {
        val fields = mapOf(
            "instruction" to instruction,
            "durationInMinutes" to durationInMinutes,
            "deadline" to deadline,
            "exactTime" to exactTime,
        )
        val messages = validateFields(fields)
        return messages + super.validate()
    }

    override fun build(): SimpleFloatingSeries {
        return SimpleFloatingSeries(
            firebaseDocId = firebaseDocId(),
            firebaseDocPrefix = null, // Will be set when saved to Firebase
            title = name() ?: "",
            description = description() ?: "",
            instruction = instruction() ?: "",
            durationInMinutes = durationInMinutes() ?: 5,
            deadline = deadline(),
            exactTime = exactTime(),
            imageUrl = imageUrl()
        )
    }

}

fun SimpleFloatingSeries.toBuilder(): SimpleFloatingSeriesBuilderNew {
    val series = this
    return SimpleFloatingSeriesBuilderNew().apply {
        setFirebaseDocId(series.firebaseDocId)
        setName(series.title)
        setDescription(series.description)
        setImageUrl(series.imageUrl)
        setInstruction(series.instruction)
        setDurationInMinutes(series.durationInMinutes)
        setDeadline(series.deadline)
        setExactTime(series.exactTime)
        markSaved()
        this.isChanged = false
    }
}
